import { ETabs } from '../types/redux/tabs';

export const CATALOGS_PATHS: Required<Record<ETabs, string>> = {
  [ETabs.Agencies]: '/agentstva/',
  [ETabs.Realtors]: '/realtors/',
};
